/* eslint-disable */
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.collection = void 0;
const firebase_1 = __importDefault(require("firebase"));
const enums_1 = require("./enums");
const localization = {
    [enums_1.Locale.en]: "",
    [enums_1.Locale.es]: "",
    [enums_1.Locale.fr]: "",
};
function now() {
    return new firebase_1.default.firestore.Timestamp(Math.floor(new Date().getTime() / 1000), 0);
}
function later() {
    return new firebase_1.default.firestore.Timestamp(now().seconds + 86400, 0);
}
function activity() {
    return {
        scene: "",
        content: {
            content: [],
            name: Object.assign({}, localization),
        },
        type: enums_1.ActivityType.Content,
    };
}
function match() {
    return {
        open: false,
        private: false,
    };
}
match.invitation = function invitation() {
    return { extendedAt: firebase_1.default.firestore.FieldValue.serverTimestamp(), inviter: "" };
};
activity.match = match;
activity.media = function media() {
    return {
        createdAt: firebase_1.default.firestore.FieldValue.serverTimestamp(),
        createdBy: "",
        details: { filename: "", originalFormat: "", size: 0, url: "" },
        locale: enums_1.Locale.en,
        MIME: enums_1.MIME["text/plain"],
        status: enums_1.MediaStatus.Processing,
    };
};
activity.participant = function participant() {
    return { start: firebase_1.default.firestore.FieldValue.serverTimestamp() };
};
function dm() {
    return {
        participants: ["", ""],
        timestamp: firebase_1.default.firestore.FieldValue.serverTimestamp(),
    };
}
function message() {
    return {
        content: false,
        role: enums_1.UserRole.Guest,
        timestamp: firebase_1.default.firestore.FieldValue.serverTimestamp(),
        user: "",
    };
}
dm.message = message;
function user() {
    return {
        approved: false,
        email: "",
        envLocation: null,
        lastActivity: null,
        registrationDate: firebase_1.default.firestore.FieldValue.serverTimestamp(),
        jobPosition: enums_1.UserRole.Guest,
        retailerCountry: enums_1.Country.US,
        reviewDate: null,
        role: enums_1.UserRole.Guest,
        tcAgreement: false,
    };
}
user.calendar = function calendar() {
    return { end: later(), start: now() };
};
user.email = function email() {
    return {
        labels: [],
        data: [],
        timestamp: firebase_1.default.firestore.FieldValue.serverTimestamp(),
        to: [],
        toUsers: [],
        userEmails: [],
    };
};
user.media = function media() {
    return {
        createdAt: now(),
        createdBy: "",
        details: { filename: "", originalFormat: "", size: 0, url: "" },
        error: false,
        locale: enums_1.Locale.en,
        MIME: enums_1.MIME["text/plain"],
        status: enums_1.MediaStatus.Processing,
        timestamp: firebase_1.default.firestore.FieldValue.serverTimestamp(),
        voiceOfGod: false,
    };
};
user.notification = function notification() {
    return {
        content: [],
        createdAt: firebase_1.default.firestore.FieldValue.serverTimestamp(),
        immediate: false,
        readAt: new firebase_1.default.firestore.Timestamp(0, 0),
        type: enums_1.Semantic.Info,
    };
};
user.score = function score() {
    return {
        activity: "",
        displayName: "",
        gameStart: firebase_1.default.firestore.FieldValue.serverTimestamp(),
    };
};
/**
 * Helper functions to create models for the documents
 * on our Firestore collections.
 */
exports.collection = {
    activity: activity,
    dm: dm,
    invitation() {
        return {
            invitedBy: "",
            timestamp: firebase_1.default.firestore.FieldValue.serverTimestamp(),
            token: "",
        };
    },
    prescreened() {
        return {
            approved: false,
            role: null,
        };
    },
    scene: {
        chatroom: {
            message: message,
        },
        touchpoint() {
            return { activity: "" };
        },
        visitor() {
            return { timestamp: firebase_1.default.firestore.FieldValue.serverTimestamp() };
        },
    },
    scorm() {
        return {
            createdAt: now(),
            createdBy: "",
            details: { filename: "", originalFormat: "application/zip", size: 0, url: "" },
            error: false,
            locale: enums_1.Locale.en,
            status: enums_1.MediaStatus.Processing,
        };
    },
    user: user,
};
//# sourceMappingURL=collections.js.map